module.exports = require("../dist/clipboard-polyfill.promise")
